import DressingRoomContext from "contexts/DressingRoomContext";
import { useContext } from "react";

const useDressingRoom = () => useContext(DressingRoomContext);

export default useDressingRoom;
